import { $ZodError, prettifyError } from 'zod/v4/core'

const getErrorMessage = (thrown: unknown, hasDetails = true): string => {
	if (thrown == null) return 'Невідома помилка'

	if (thrown instanceof $ZodError) {
		try {
			return prettifyError(thrown)
		} catch {
			// prettifyError падає на issue нестандартної форми — тоді працюють гілки нижче.
		}
	}

	if (thrown instanceof Error) return thrown.message || 'Невідома помилка'

	// eslint-disable-next-line @typescript-eslint/no-base-to-string
	if (typeof thrown !== 'object') return String(thrown)

	const error = thrown as Record<string, unknown>

	if (hasDetails && Array.isArray(error.details) && error.details.length > 0) {
		const relevant = error.details
			.filter((d): d is string => typeof d === 'string')
			.map((d) => d.trim())
			.filter(Boolean)

		if (relevant.length > 0) return relevant.join('; ')
	}

	if (typeof error.message === 'string') {
		const t = error.message.trim()
		if (t) return t
	}

	if (typeof error.code === 'string') {
		const t = error.code.trim()
		if (t) return t
	}

	// eslint-disable-next-line @typescript-eslint/no-base-to-string
	return String(thrown)
}

export default getErrorMessage
